exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-groups-operatinghours-style__hoursContainer{margin:0 auto;margin-bottom:10px;min-height:112px}.nil-sa-groups-operatinghours-style__spinnerContainer{margin-left:10px}.nil-sa-groups-operatinghours-style__hoursHeader{font-weight:600;font-size:17px;margin-bottom:10px;height:40px}.nil-sa-groups-operatinghours-style__outerRow{padding-top:10px}.nil-sa-groups-operatinghours-style__innerRow{padding-bottom:5px}.nil-sa-groups-operatinghours-style__hoursDay{text-align:right}.nil-sa-groups-operatinghours-style__hoursTime{text-align:left}.nil-sa-groups-operatinghours-style__hoursCol{padding-top:0}.nil-sa-groups-operatinghours-style__showMore{text-align:center;cursor:pointer;padding-top:10px;font-size:16px}.nil-sa-groups-operatinghours-style__subHeader{font-weight:200}.nil-sa-groups-operatinghours-style__open{color:#007400}.nil-sa-groups-operatinghours-style__closed{color:#cd2600}@media only screen and (max-width:768px){.nil-sa-groups-operatinghours-style__hoursContainer{width:100%}}", ""]);

// exports
exports.locals = {
	"hoursContainer": "nil-sa-groups-operatinghours-style__hoursContainer",
	"spinnerContainer": "nil-sa-groups-operatinghours-style__spinnerContainer",
	"hoursHeader": "nil-sa-groups-operatinghours-style__hoursHeader",
	"outerRow": "nil-sa-groups-operatinghours-style__outerRow",
	"innerRow": "nil-sa-groups-operatinghours-style__innerRow",
	"hoursDay": "nil-sa-groups-operatinghours-style__hoursDay",
	"hoursTime": "nil-sa-groups-operatinghours-style__hoursTime",
	"hoursCol": "nil-sa-groups-operatinghours-style__hoursCol",
	"showMore": "nil-sa-groups-operatinghours-style__showMore",
	"subHeader": "nil-sa-groups-operatinghours-style__subHeader",
	"open": "nil-sa-groups-operatinghours-style__open",
	"closed": "nil-sa-groups-operatinghours-style__closed"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/groups/OperatingHours/style.less
// module id = 256
// module chunks = 0